import React, { useState, createContext, useEffect, useContext } from "react";
import { AuthContext } from "./AuthContext";
import axios from "axios";
import { useMsal } from "@azure/msal-react";
import { DATABOOK_API } from "./constants/serverConfig";
import { protectedResources } from "./msalConfig";
import { TREE_DATA_JSON } from "./constants/Constant";


export const NavBarAndLandingPageContext = createContext();

export const NavBarAndLandingPageProvider = ({ children }) => {

    const [roletoggle, setRoleToggle] = useState(false);
    const [searchKeyword, setSearchKeyword] = useState({
        criteria: "dataset-name",
        term: ""
    });
    const [selectedoutputportcontext, setSelectedOutputPort] = useState("");
    const [tabcriteria, setTabCriteria] = useState(TREE_DATA_JSON);
    const { getToken, token, error, } = useContext(AuthContext);
    const { instance } = useMsal();
    const account = instance.getActiveAccount();
    const request = {
        scopes: protectedResources.databook.scopes,
        account: account,
    };

    const [browseData, setBrowseData] = useState({
        catalogs: []
    });
    const [metricData, setMetricData] = useState({
        catalogs: []
    });

    const [outputPort, setOutputPort] = useState("");


    const METRIC_API = `${DATABOOK_API}/browse/catalog?type=metric`;
    const BROWSEAPI = `${DATABOOK_API}/browse/catalog?type=&outputPort=${selectedoutputportcontext.value}`;

    // const getBrowseData = (source) => {
    //     axios
    //         .get(BROWSEAPI, {
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 Authorization: "Bearer " + token,
    //             },
    //         })
    //         .then((res) => {

    //             setBrowseData(res.data);
    //         });

    // Metric api comment as of now, will be enabled in future

    // axios
    //     .get(METRIC_API, {
    //         headers: {
    //             "Content-Type": "application/json",
    //             Authorization: "Bearer " + token,
    //         },
    //     })
    //     .then((res) => {
    //         let filtercatalog = res.data.catalogs.filter((cata) => {
    //             return cata.name !== "Product";
    //         })
    //         // "Product"
    //         setMetricData(res.data);
    //     });
    // };

    const getLandingPageSources = () => {
        // setIsSourceFetching(true);
        // (async () => await getToken())();
        axios
            .get(`${DATABOOK_API}/datasets/output-ports`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },

            })
            .then((response) => {
                let array = response.data?.map((item) => ({ value: item, label: item }))
                array.unshift({ value: "all", label: "All" })
                setSelectedOutputPort(array[0].value)
                setOutputPort(array);
                // getBrowseData("")
                // setOutputPort(array);
                // setIsFetching(false);
                // setIsSourceFetching(false);
            })
            .catch((error) => {
                // setIsSourceFetching(false);
            })
    };



    // useEffect(() => {
    //     const fetchdatasets = async () => {
    //         (async () => await getToken())();
    //         if (selectedoutputport.value) {
    //             getBrowseData(selectedoutputport.value);
    //             // getLandingPageSources();
    //         };
    //         if (error) {
    //             try {
    //                 const rtoken = (await instance.acquireTokenRedirect(request))
    //                     .accessToken;

    //                 getBrowseData(selectedoutputport.value);
    //             } catch (error) {
    //                 console.log(error);
    //             }
    //         }
    //     };

    //     fetchdatasets();
    // }, [token, selectedoutputport]);

    useEffect(() => {
        const fetchdatasets = async () => {
            (async () => await getToken())();
            if (token) {
                // getBrowseData(selectedoutputport.value);
                getLandingPageSources(token);
            };
            if (error) {
                try {
                    const rtoken = (await instance.acquireTokenRedirect(request))
                        .accessToken;

                    getLandingPageSources(token);
                } catch (error) {
                    console.log(error);
                }
            }
        };

        fetchdatasets();
    }, [token]);



    return (
        <NavBarAndLandingPageContext.Provider value={{
            setRoleToggle,
            roletoggle,
            setSearchKeyword,
            searchKeyword,
            browseData,
            metricData,
            tabcriteria,
            setTabCriteria,
            setSelectedOutputPort,
            selectedoutputportcontext,
            setBrowseData,
            outputPort
        }}>
            {children}
        </NavBarAndLandingPageContext.Provider>
    );
};
